import { render, staticRenderFns } from "./smartproducts.vue?vue&type=template&id=a9b33e88&scoped=true&"
import script from "./smartproducts.vue?vue&type=script&lang=js&"
export * from "./smartproducts.vue?vue&type=script&lang=js&"
import style0 from "./smartproducts.vue?vue&type=style&index=0&id=a9b33e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b33e88",
  null
  
)

export default component.exports